import { render, staticRenderFns } from "./province-tab.vue?vue&type=template&id=4d16a626"
import script from "./province-tab.vue?vue&type=script&lang=js"
export * from "./province-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports